<template>
  <div id="storeProfilePage">
    <NavBar :active="isOnline" class="overflow-y-hidden"/>
    <div class="row">
      <div class="col-12 col-md-8 col-lg-6 mx-auto">
        <v-main class="overflow-hidden">
          <div class="container-fluid">
            <div v-if="isLoaded" class="row ">
              <div class="col-4 text-center">
                <v-avatar size="80">
                  <img :src="$replaceHttps(storeDetail.PictureLogoUrl)" alt="لوگو فروشگاه">
                </v-avatar>
                <div class="row">
                  <div class="col-12">
                    <v-btn :class="isFollow ? true :'black--text'" :color="isFollow ? 'primary':'white'" block
                           class="rounded-lg" depressed
                           small @click="follow">
                      <span v-if="isFollow">دنبال شد</span>
                      <span v-else>دنبال کردن</span>
                    </v-btn>
                  </div>
                  <div class="py-1  col-12 ">{{ storeDetail.CountFollower }} دنبال کننده</div>
                  <div class="py-1  col-12 px-0">{{ storeDetail.CountVisit }} مشاهده</div>
                  <div class="py-1  col-12  px-0"><i class="fa-solid fa-star yellow--text"></i>{{
                      $roundNum(avgVote)
                    }}
                  </div>
                </div>

              </div>
              <div class="col-8">
                <h1 class="primary-text">{{ storeDetail.Name }}</h1>
                <div class="mt-1">{{ storeDetail.ShoppingCategoryName }}</div>
                <div class="line-before mt-2">Bio</div>
                <div class="brand-info-description" v-html="storeDetail.Description"></div>
                <div class="line-before py-2"><i class="fal fa-phone-volume font-weight-bold"></i></div>
                <div><span class="float-right" @click="openPhone(storeDetail.MobilePhone)">
          {{ storeDetail.MobilePhone }}</span><span
                    class=" mr-5 pr-5" @click="openPhone(storeDetail.StaticPhone)">
          {{ storeDetail.StaticPhone }}</span>
                </div>
                <div class="line-before "><i class="fal fa-map-marker-alt font-weight-bold pointer"
                                             @click="openMap(storeDetail.Latitude,storeDetail.Longitude)"></i>
                </div>
                <div class="pointer" @click="openMap(storeDetail.Latitude,storeDetail.Longitude)"> {{
                    storeDetail.Address
                  }}
                  - پلاک {{ storeDetail.Plak }} - واحد
                  {{ storeDetail.Vahed }}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 ">
                <div class="d-flex justify-space-around primary-border-top py-3">
                  <div><i :class="showProductListTab ? 'font-weight-bold':''" class="fa-2xl far fa-bag-shopping pointer"
                          @click="productListTab"></i></div>
                  <div><i :class="showGalleryTab ? 'font-weight-bold':''" class="fa-2xl far fa-photo-film pointer"
                          @click="galleryTab"></i></div>
                  <div><i :class="showCommentsTab ? 'font-weight-bold':''" class="fa-2xl far fa-comments pointer"
                          @click="commentsTab"></i></div>
                  <div><i :class="showTransportationTab ? 'font-weight-bold':''" class="fa-2xl far fa-truck pointer"
                          @click="transportationTab"></i></div>
                </div>
              </div>
            </div>
            <div v-if="showProductListTab" class="row">
              <div v-if="products.length=== 0" class="col-12  text-center mt-10">
                <div><i class="fa-light fa-face-frown-slight fa-3x grey--text"></i></div>
                <div class="mt-2">
                  موردی یافت نشد
                </div>

              </div>
              <div v-else class="col-12">
                <div class="row">
                  <div class="col pt-0 pl-0">
                    <v-text-field
                        v-model="searchKeyWord"
                        append-icon="far fa-magnifying-glass"
                        class="rounded-lg"
                        clearable
                        dense
                        flat
                        hide-details
                        solo
                        @keydown="search"
                        @click:clear="clearSearchResult">
                    </v-text-field>
                  </div>
                  <div class="col-auto pt-0 px-0">
                    <v-btn icon @click="openSortBox">
                      <i class="fa-solid fa-sliders fa-xl"></i>
                    </v-btn>
                  </div>
                </div>
              </div>
              <div v-if="isProductsLoaded" class="col-12">
                <div class="row">

                  <div v-for="(item,i) in products" :key="i" class="col-12 py-0">
                    <ProductListsCard :item="item"/>
                  </div>
                </div>
              </div>
              <div id="sortBox" class="sort-box bg-white p-2">
                <v-btn icon @click="closeSortBox">
                  <i class="fa-solid fa-circle-xmark fa-xl"></i>
                </v-btn>
                <div class="row mx-2 light-gray-bg  rounded-lg ">
                  <div class="col-3 "><i class="fa-solid fa-sliders fa-xl"></i></div>
                  <div class="col-9 ">مرتب سازی</div>
                </div>
                <v-radio-group v-model="filterSelected">
                  <v-radio
                      v-for="(item,i) in filterItems"
                      :key="i+1"
                      :label="item"
                      :value="i+1"
                      @change="sort(i+1)"
                  ></v-radio>
                </v-radio-group>
              </div>
            </div>
            <div v-if="showGalleryTab">
              <div class="row">

                <div class="col-12">
                  <div class="row">
                    <div class="col pt-0 ">
                      <v-text-field
                          v-model="searchGalleryKeyWord"
                          append-icon="far fa-magnifying-glass"
                          class="rounded-lg"
                          clearable
                          dense
                          flat
                          hide-details
                          solo
                          @change="searchGallery"
                          @click:append="searchGallery"
                          @click:clear="clearSearchGalleryResult">
                      </v-text-field>
                    </div>
                    <div class="col-auto pt-0 pr-1">
                      <v-btn icon @click="openFilterSheet = true">
                        <i class="fa-solid fa-sliders fa-xl"></i>
                      </v-btn>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="items.length=== 0" class="col-12  mt-10  text-center">
                <div><i class="fa-light fa-face-frown-slight fa-3x grey--text"></i></div>
                <div class="mt-2">
                  موردی یافت نشد
                </div>

              </div>
              <masonry v-else
                       :cols="{default: 4, 1000: 3, 700: 2}">
                <router-link v-for="(item,i) in items" :key="i"
                             :to="{name:'TrendDetail',query:{VendorSocialNetworkID:item.VendorSocialNetworkID}}"
                             class="p-1 mx-auto d-block">
                  <v-img v-if="item.FileCoverUrl !== null" :src="$replaceHttps(item.FileCoverUrl)"
                         class=" rounded-11px">
                    <div class="p-2">
                      <div v-if="item.TypeStrucGallery ===2"><i
                          class="fa-solid fa-play white--text fa-lg shadow-lg"></i></div>
                      <div v-if="item.TypeStrucGallery ===1"><i class="fa-solid fa-images white--text fa-lg shadow"></i>
                      </div>
                    </div>
                  </v-img>
                  <v-img v-else :src="$replaceHttps(item.FileUrl)" class=" rounded-11px">
                    <div class="p-2">
                      <div v-if="item.TypeStrucGallery ===2"><i
                          class="fa-solid fa-play white--text fa-lg shadow-lg"></i></div>
                      <div v-if="item.TypeStrucGallery ===1"><i class="fa-solid fa-images white--text fa-lg shadow"></i>
                      </div>
                    </div>
                  </v-img>
                </router-link>
              </masonry>
              <v-bottom-sheet v-model="openFilterSheet" class="bottom-sheet">
                <v-sheet
                    class="rounded-t-xl">
                  <div class="row no-gutters align-items-center">
                    <div class="col-auto font-weight-bold pr-8 primary-text">
                      <i class="fa-solid fa-sliders fa-xl"></i>
                    </div>
                    <div class="col pr-5 py-2 toggle-filter-btn">
                      <v-btn-toggle
                          v-model="typeSelected"
                          group
                          tile
                          @change="searchTypeGallerySelected">
                        <v-btn value="1">
                          همه
                        </v-btn>
                        <v-btn value="2">
                          عکس
                        </v-btn>
                        <v-btn value="3">
                          فیلم
                        </v-btn>
                      </v-btn-toggle>
                    </div>
                    <div class="col text-left pl-4">
                      <v-btn
                          icon
                          @click="openFilterSheet = !openFilterSheet">
           <span class="fa-stack font16px bottom-sheet">
             <i class="fa-solid fa-clock-seven fa-stack-2x black--text"></i>
             <i class="fa-solid fa-circle-xmark fa-stack-1x fa-inverse white--text"></i>
           </span>
                      </v-btn>
                    </div>
                  </div>

                </v-sheet>
              </v-bottom-sheet>

            </div>
            <div v-if="showCommentsTab" class="row">
              <div class="col-12 primary-text text-center">
                نظر خود را درباره عملکرد فروشگاه بنویسید
              </div>
              <div class="col-12">
                <div class="row">
                  <div class="col-12">
                    <v-textarea
                        v-model="commentDescription"
                        auto-grow
                        flat
                        full-width
                        hide-details
                        rows="4"
                        solo>
                    </v-textarea>
                  </div>
                  <div class="col-3 pl-0 text-center">
                    امتیاز دهید
                  </div>
                  <div class="col-6 px-0">
                    <v-rating
                        v-model="rate"
                        background-color="black"
                        color="yellow"
                        dense
                        length="10"
                        size="18"
                    ></v-rating>
                  </div>
                  <div class="col-3 text-left pr-0">
                    <v-btn class="pl-1 pb-1" icon small @click="registerComment">
                      <i class="fa-solid fa-square-check font24px black--text"></i>
                    </v-btn>
                  </div>


                </div>
              </div>
              <div class="col-12 py-0">
                <span class="font16px">نظرات </span> <i class="fa-solid fa-left-long fa-lg mr-1"></i>
              </div>

              <div v-if="comments.length === 0" class="col-12 text-center">
                <div><i class="fa-light fa-face-frown-slight fa-3x grey--text"></i></div>
                <div class="mt-2">
                  هنوز نظری ثبت نشده است
                </div>

              </div>
              <div v-else class="col-12">
                <div v-for="item in comments" :key="item.id" class="row ">
                  <div class="col-9 forth-bg rounded-lg pl-1" @click="goToCommentOwner(item)">
                    <v-avatar size="38">
                      <img v-if="item.AppUserUrl !== null" :src="$replaceHttps(item.AppUserUrl)"
                           alt="تصویر کاربر">
                      <i v-else class="fas fa-circle-user fa-3x"></i>

                    </v-avatar>
                    <span class="font-weight-bold mr-1 d-inline-block" dir="ltr">: {{ item.AppUserName }} </span>
                    <span class="font-weight-normal" v-html="item.Description"></span>
                  </div>
                  <div class="col-3 text-left">
                    <div>{{ $convertDate(item.ModifiedDate) }}</div>
                    <div>{{ item.Rate }} <i class="fa-solid fa-star yellow--text"></i></div>
                  </div>
                  <div class="col-12">
                    <div v-if="item.AnswerDescription !== null" class="row">
                      <div class="col-1"><i class="fa-solid fa-arrow-turn-down-left fa-lg"></i></div>
                      <div class="col-8 forth-bg rounded-lg pb-0">
                        <v-avatar size="38">
                          <img :src="$replaceHttps(item.VendroPictureUrl)" alt="تصویر پاسخ دهنده">
                        </v-avatar>
                        <span class="font-weight-bold mr-1 d-inline-block">{{ item.Name }} :</span>
                        <span class="font-weight-normal">{{ item.AnswerDescription }}</span>
                      </div>
                      <div class="col-3 text-left pb-0 reply-comments-action pr-0">
                        <div>{{ $convertDate(item.AnswerDate) }}</div>
                        <div>{{ item.CountLike }}
                          <v-btn icon small @click="like(item.VoteID)"><i
                              class="fa-solid fa-thumbs-up fa-xl  green--text"></i></v-btn>
                        </div>
                        <div>{{ item.CountDislike }}
                          <v-btn icon small @click="dislike(item.VoteID)"><i
                              class="fa-solid fa-thumbs-down fa-xl  red--text"></i></v-btn>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div v-if="showTransportationTab" class="row">
              <div class="col-12 text-center">
                <i class="fa-solid fa-period"></i>
                در هنگام خرید به اصالت فروشگاه – کیفیت کالا – نحوه پرداخت و.... فروشگاه مورد نظر توجه گردد . مسئولیت
                خرید و
                پرداخت کاملا بر عهده <span class="text-decoration-underline green--text">خریدار و فروشنده</span> می باشد
                و
                پلتفرم <span class="text-decoration-underline text-gold">ایوان خانه</span> هیچ گونه مسئولیتی در قبال
                خرید یا
                فروش شما و
                منفعتی در فروش ندارد لذا از خریداران محترم خواهش می شود در فرآیند خرید خود از فروشگاه مورد نظر خود <span
                  class="text-decoration-underline green--text">دقت</span> کنند.
              </div>
              <div class="col-12 border-top-primary mx-3">
                <div class="font16px primary-text pointer" @click="openAccountInformationBox"><i
                    class="fa-solid fa-arrow-up-arrow-down font16px"></i> روش های آفلاین خرید و ثبت سفارش از این فروشگاه
                </div>
                <div class="font16px mt-2 pointer primary-text" @click="openDownloadTariffBox"><i
                    class="fa-regular fa-dollar-sign font16px"></i> تعرفه های بارگیری این فروشگاه
                </div>
              </div>
              <div id="downloadTariffBox" class="tariff-box bg-white p-2">
                <v-btn icon @click="closeDownloadTariffBox">
                  <i class="fa-solid fa-circle-xmark fa-xl"></i>
                </v-btn>
                <div class="row mx-2 light-gray-bg  rounded-lg ">
                  <div class="col-3 "><i class="fa-solid fa-dollar-sign fa-xl"></i></div>
                  <div class="col-9 ">تعرفه های بارگیری</div>
                </div>
                <div class="row mx-2">
                  <div v-if="transferData.IsActiveSendByMotor" class="col-12">
                <span class=" primary-text"><i
                    class="fas fa-motorcycle transform-icon ml-1 font16px"></i> پیک موتوری</span>
                    <span class="float-left">
                      <span v-if="transferData.SendByMotor ===0" class="font-weight-bold primary-text">رایگان</span>
             <span v-else class="font-weight-bold primary-text">
               {{ $numberWithCommas(transferData.SendByMotor) }} تومان</span>
           </span>
                  </div>
                  <div v-if="transferData.IsActiveSendByVanetSabok" class="col-12">
                <span class=" primary-text"><i
                    class="far fa-wagon-covered transform-icon ml-1 font16px"></i>وانت سبک</span>
                    <span class="float-left">
             <span v-if="transferData.SendByVanetSabok ===0" class="font-weight-bold primary-text">رایگان</span>
             <span v-else class="font-weight-bold primary-text">{{ $numberWithCommas(transferData.SendByVanetSabok) }} تومان</span>
           </span>
                  </div>
                  <div v-if="transferData.IsActiveVanetSangin" class="col-12">
            <span class=" primary-text"><i
                class="far fa-truck-pickup transform-icon ml-1 font16px"></i> وانت سنگین</span>
                    <span class="float-left">
                      <span v-if="transferData.SendByVanetSangin ===0"
                            class="font-weight-bold primary-text">رایگان</span>
             <span v-else class="font-weight-bold primary-text">{{ $numberWithCommas(transferData.SendByVanetSangin) }} تومان</span>
           </span>
                  </div>
                  <div v-if="transferData.IsActiveSendByKhavarMamuli" class="col-12">
            <span class=" primary-text"><i
                class="far fa-truck-container transform-icon ml-1 font16px"></i>خاورمسقف</span>
                    <span class="float-left">
                      <span v-if="transferData.SendByKhavarMamuli ===0"
                            class="font-weight-bold primary-text">رایگان</span>
             <span v-else class="font-weight-bold primary-text">{{ $numberWithCommas(transferData.SendByKhavarMamuli) }} تومان</span>
           </span>
                  </div>
                  <div v-if="transferData.IsActiveSendByKhavarBozorg" class="col-12">
                    <span class=" primary-text"><i
                        class="fas fa-truck transform-icon ml-1 font16px"></i> خاور بزرگ</span>
                    <span class="float-left">
                      <span v-if="transferData.IsActiveSendByKhavarBozorg ===0" class="font-weight-bold primary-text">رایگان</span>
             <span v-else
                   class="font-weight-bold primary-text">{{
                 $numberWithCommas(transferData.SendByKhavarBozorg)
               }} تومان</span>

           </span>
                  </div>
                  <div v-if="transferData.IsActiveSendByIsuzu" class="col-12">
                    <span class=" primary-text"><i class="far fa-truck transform-icon ml-1 font16px"></i>ایسوزو</span>
                    <span class="float-left">
            <span v-if="transferData.SendByIsuzu ===0" class="font-weight-bold primary-text">رایگان</span>
             <span v-else class="font-weight-bold primary-text">{{
                 $numberWithCommas(transferData.SendByIsuzu)
               }} تومان</span>
           </span>
                  </div>
                  <div v-if="transferData.IsActiveSendByKainunMamuli" class="col-12">
                    <span class=" primary-text"><i class="fas fa-truck-container transform-icon ml-1 font16px"></i>کامیون معمولی</span>
                    <span class="float-left">
                        <span v-if="transferData.SendByKainunTak ===0"
                              class="font-weight-bold primary-text">رایگان</span>
             <span v-else class="font-weight-bold primary-text">{{ $numberWithCommas(transferData.SendByKainunTak) }} تومان</span>
           </span>
                  </div>
                  <div v-if="transferData.IsActiveSendByKainunTak" class="col-12">
                <span class=" primary-text"><i
                    class="fas fa-truck-field transform-icon ml-1 font16px"></i>کامیون تک</span>
                    <span class="float-left">
                         <span v-if="transferData.SendByKainunTak ===0"
                               class="font-weight-bold primary-text">رایگان</span>
             <span v-else class="font-weight-bold primary-text">{{ $numberWithCommas(transferData.SendByKainunTak) }} تومان</span>
                    </span>
                  </div>
                  <div v-if="transferData.IsActiveSendByKainunJoft" class="col-12">
                <span class=" primary-text"><i
                    class="far fa-truck-field transform-icon ml-1 font16px"></i>کامیون جفت</span>
                    <span class="float-left">
                           <span v-if="transferData.SendByKainunJoft ===0"
                                 class="font-weight-bold primary-text">رایگان</span>
             <span v-else class="font-weight-bold primary-text">{{ $numberWithCommas(transferData.SendByKainunJoft) }} تومان</span>
           </span>
                  </div>
                </div>


              </div>
              <div id="accountInformationBox" class="account-info-box bg-white p-2 overflow-auto">
                <v-btn icon @click="closeAccountInformationBox">
                  <i class="fa-solid fa-circle-xmark fa-xl"></i>
                </v-btn>
                <div class="row mx-2 light-gray-bg  rounded-lg ">
                  <div class="col-1 "><i class="fa-solid fa-arrow-up-arrow-down fa-xl"></i></div>
                  <div class="col-10 text-center">اطلاعات حساب و روش آفلاین خرید</div>
                </div>
                <div class="row mx-2">
                  <div class="col-12">
                    <ol>
                      <li>ابتدا سبد خرید خود را کامل کنید.</li>
                      <li>دکمه ثبت سفارش را بزنید.</li>
                      <li>سفارش شما در پنل فروشگاه ثبت میشود.</li>
                      <li>شما میتوانید مبلغ خرید خود را بعد از تماس و صحت سنجی فروشگاه به شماره حساب هایی که در اطلاعات
                        حساب
                        هر
                        فروشگاه هست پرداخت نمایید و عکس واریزی خود را آپلود نمایید.
                      </li>
                      <li>فروشگاه پس از پرداخت اقدام به آماده سازی و ارسال خرید شما میکند.</li>
                      <li>شما میتوانید مراحل خرید خود را در پروفایل خود مشاهده نمایید.</li>
                    </ol>
                  </div>
                  <div v-if="transferData.IsActiveCard" class="col-12 p-0">
                    <i class="fa-solid fa-period"></i>
                    <span class="font16px mr-2">شماره حساب فروشگاه</span>
                    <div class="light-gray-bg rounded-lg text-center p-3 mt-2">
                      <div>{{ transferData.CardOne }}</div>
                      <div>{{ transferData.CardTwo }}</div>
                      <div>{{ transferData.CardThree }}</div>
                    </div>
                  </div>
                  <div v-if="transferData.IsActivePhone" class="col-12 p-0 mt-5">
                    <i class="fa-solid fa-period"></i>
                    <span class="font16px mr-2">شماره تماس جهت ثبت سفارش تلفنی </span>
                    <div class="light-gray-bg rounded-lg text-center p-3 mt-2">
                      <a :href="'tel:'+transferData.PhoneOne" target="_blank">{{ transferData.PhoneOne }}</a>
                      <a :href="'tel:'+transferData.PhoneTwo" target="_blank">{{ transferData.PhoneTwo }}</a>
                      <a :href="'tel:'+transferData.PhoneThree" target="_blank">{{ transferData.PhoneThree }}</a>
                    </div>
                  </div>
                  <div v-if="transferData.IsActiveWhatsapp" class="col-12 p-0 mt-5">
                    <i class="fa-solid fa-period"></i>
                    <span class="font16px mr-2">شماره واتس آپ </span>
                    <div class="light-gray-bg rounded-lg text-center p-3 mt-2">
                      <a :href="'https://wa.me/+98'+ transferData.PhoneWhatsappOne" target="_blank">{{
                          transferData.PhoneWhatsappOne
                        }}</a>
                      <a :href="'https://wa.me/+98'+ transferData.PhoneWhatsappTwo" target="_blank">{{
                          transferData.PhoneWhatsappTwo
                        }}</a>
                      <a :href="'https://wa.me/+98'+ transferData.PhoneWhatsappThree" target="_blank">{{
                          transferData.PhoneWhatsappThree
                        }}</a>
                    </div>
                  </div>
                  <div v-if="transferData.IsActiveTelegram" class="col-12 p-0 mt-5">
                    <i class="fa-solid fa-period"></i>
                    <span class="font16px mr-2">شماره تلگرام </span>
                    <div class="light-gray-bg rounded-lg text-center p-3 mt-2">
                      <a :href="'https://t.me/+98'+transferData.PhoneTelegramOne"
                         target="_blank">{{ transferData.PhoneTelegramOne }}</a>
                      <a :href="'https://t.me/+98'+transferData.PhoneTelegramTwo"
                         target="_blank">{{ transferData.PhoneTelegramTwo }}</a>
                      <a :href="'https://t.me/+98'+transferData.PhoneTelegramThree"
                         target="_blank">{{ transferData.PhoneTelegramThree }}</a>
                    </div>
                  </div>
                  <div v-if="transferData.IsActiveLink" class="col-12 p-0 mt-5">
                    <i class="fa-solid fa-period"></i>
                    <span class="font16px mr-2">آیدی اینستاگرام </span>
                    <div class="light-gray-bg rounded-lg text-center p-3 mt-2">
                      <a :href="'https://www.instagram.com/'+transferData.LinkOne"
                         target="_blank">{{ transferData.LinkOne }}</a>
                      <a :href="'https://www.instagram.com/'+transferData.LinkTwo"
                         target="_blank">{{ transferData.LinkTwo }}</a>
                      <a :href="'https://www.instagram.com/'+transferData.LinkThree"
                         target="_blank">{{ transferData.LinkThree }}</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-main>
      </div>
    </div>
    <v-overlay :value="showLoaderDialog">
      <div class="loading-spinner">
      </div>
    </v-overlay>
    <v-snackbar
        v-model="showResult"
        :multi-line="true"
        color="primary">
      {{ resultText }}

      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" icon @click="showResult = false ">
          <i class="fa-solid fa-circle-xmark fa-xl white--text"></i>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import ProductListsCard from "@/components/ProductListsCard";
import NavBar from "@/components/NavBar";

export default {
  name: "StoreProfile",
  metaInfo: {
    title: 'ایوان خانه- پروفایل فروشگاه',
  },
  components: {NavBar, ProductListsCard},
  data: () => ({
    products: [],
    showLoaderDialog: false,
    isProductsLoaded: false,
    isFollow: false,
    isLoaded: false,
    storeDetail: {},
    filterItems: ['پیش فرض', 'جدیدترین', 'کمترین قیمت', 'بیشترین قیمت', 'بیشترین فروش', 'بیشترین بازدید', 'محبوب ترین'],
    showProductListTab: true,
    showGalleryTab: false,
    showCommentsTab: false,
    showTransportationTab: false,
    openFilterSheet: false,
    items: [],
    comments: [],
    typeSortSelected: null,
    userSelectedTypeSort: false,
    searchKeyWord: null,
    searchGalleryKeyWord: null,
    typeSearchSelected: false,
    typeSelected: null,
    avgVote: 0,
    transferData: {},
    filterSelected: 1,
    isOnline: '',
    commentDescription: '',
    showResult: false,
    resultText: '',
    rate: null,


  }),
  mounted() {
    this.getStoreDetail()
    this.getProducts()
    this.getGallery()
  },
  methods: {
    checkUserFollowing() {
      let following = this.$store.getters.getUserFollowings
      let id = this.$route.query.VendorID
      if (following.find(x => x.VendorID === id) !== undefined) {
        this.isFollow = true
      }
    },
    getStoreDetail() {
      let requestOptions = {
        method: 'GET',
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "SearchEngine/SpecialVendor?VendorID=" + this.$route.query.VendorID, requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.storeDetail = json.VendorViewModel
            if (json.VendorViewModel.IsOnlineVendor) {
              this.isOnline = 'online'
            } else {
              this.isOnline = 'offline'
            }
            this.comments = json.VoteViewModel
            let votes = json.VoteViewModel
            let num = votes.length
            let sumVote = 0

            for (let j = 0; j < votes.length; j++) {
              sumVote += votes[j].Rate
            }
            let avg = sumVote / num;
            if (avg > 0) {
              this.avgVote = sumVote / num
            } else {
              this.avgVote = 0
            }

            if (json.VendorInformationModel !== null) {
              this.transferData = json.VendorInformationModel
            }
            this.isLoaded = true
            this.checkUserFollowing()

          })
          .catch(error => console.log('error', error));
    },
    getProducts() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("VendorID", this.$route.query.VendorID);
      if (this.userSelectedTypeSort === true) {
        urlencoded.append("TypeSearchEngineSort", this.typeSortSelected);
      }
      if (this.searchKeyWord !== null && this.searchKeyWord !== '') {
        urlencoded.append("KeyWord", this.searchKeyWord);
      }

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      let resStatus = null
      fetch(this.$baseUrl + "SearchEngine/_ListProduct", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {
            if (resStatus === 200) {
              let products = JSON.parse(result);
              for (let i = 0; i < products.length; i++) {
                products[i].tip = products[i].VendorProductTipViewModels[0]

                let voteArr = products[i].VoteViewModel

                let num = voteArr.length
                let sumVote = 0
                for (let j = 0; j < voteArr.length; j++) {
                  sumVote += voteArr[j].Rate
                }
                let avg = sumVote / num;
                if (avg > 0) {
                  products[i].avgVote = sumVote / num
                } else {
                  products[i].avgVote = 0
                }
              }
              this.products = products;
            } else {
              this.products = []
            }
            this.isProductsLoaded = true;
            this.showLoaderDialog = false;
          })
          .catch(error => console.log('error', error));
    },
    getGallery() {
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("VendorID", this.$route.query.VendorID);
      urlencoded.append("pageIndex", "0");
      urlencoded.append("pageSize", "200000");
      if (this.searchGalleryKeyWord !== null && this.searchGalleryKeyWord !== '') {
        urlencoded.append("KeyWord", this.searchGalleryKeyWord);
      }
      if (this.typeSearchSelected) {
        urlencoded.append("TypeSocialNetworkSort", this.typeSelected);
        this.showLoaderDialog = true

      }


      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };
      let resStatus = null
      fetch(this.$baseUrl + "SearchSocialNetwork/_List", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {
            if (resStatus === 200) {
              let json = JSON.parse(result)
              this.items = json.list.filter(x => x.IsActive === true)
            } else {
              this.items = []
            }
            this.showLoaderDialog = false

          })
          .catch(error => console.log('error', error));
    },
    follow() {
      this.showLoaderDialog = true

      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let urlencoded = new URLSearchParams();
      urlencoded.append("VendorID", this.$route.query.VendorID);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };
      let resStatus = null
      fetch(this.$baseUrl + "CommonMethod/SetFollowVendor", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {
            if (resStatus === 200) {
              this.isFollow = !this.isFollow
              this.$store.commit('addOrRemoveFollowingItemToList', this.$route.query.VendorID)
              this.getStoreDetail()
            }
            this.showLoaderDialog = false
            this.resultText = result
            this.showResult = true

          })
          .catch(error => console.log('error', error));
    },
    openPhone(tel) {
      this.$openLink("tel:" + tel)
    },
    openSortBox() {
      document.getElementById('sortBox').classList.add('open')
    },
    closeSortBox() {
      document.getElementById('sortBox').classList.remove('open')

    },
    openDownloadTariffBox() {
      document.getElementById('downloadTariffBox').classList.add('open')
    },
    closeDownloadTariffBox() {
      document.getElementById('downloadTariffBox').classList.remove('open')

    },
    openAccountInformationBox() {
      document.getElementById('accountInformationBox').classList.add('open')
    },
    closeAccountInformationBox() {
      document.getElementById('accountInformationBox').classList.remove('open')

    },
    productListTab() {
      this.showProductListTab = true;
      this.showGalleryTab = false;
      this.showCommentsTab = false;
      this.showTransportationTab = false;

    },
    galleryTab() {
      this.showProductListTab = false;
      this.showGalleryTab = true;
      this.showCommentsTab = false;
      this.showTransportationTab = false;

    },
    commentsTab() {
      this.showProductListTab = false;
      this.showGalleryTab = false;
      this.showCommentsTab = true;
      this.showTransportationTab = false;

    },
    transportationTab() {
      this.showProductListTab = false;
      this.showGalleryTab = false;
      this.showCommentsTab = false;
      this.showTransportationTab = true;
    },
    sort(i) {
      this.userSelectedTypeSort = true
      this.typeSortSelected = i
      this.closeSortBox()
      this.getProducts()
    },
    search(e) {
      if (e.keyCode === 13) {
        this.getProducts()
      }
    },
    clearSearchResult() {
      this.searchKeyWord = null
      this.getProducts()
    },
    searchGallery() {

      this.getGallery()

    },
    clearSearchGalleryResult() {
      this.searchGalleryKeyWord = null
      this.getGallery()
    },
    searchTypeGallerySelected() {
      this.typeSearchSelected = true
      this.openFilterSheet = false
      this.getGallery()
    },
    registerComment() {
      this.openCommentSheet = false
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("RelationID", this.$route.query.VendorID);
      urlencoded.append("Rate", this.rate);
      urlencoded.append("Description", this.commentDescription);
      urlencoded.append("TypeVote", "3");

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "CommonMethod/SetVote", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.showLoaderDialog = false
            this.resultText = result
            this.showResult = true
            this.commentDescription = ''
            this.rate = null

          })
          .catch(error => console.log('error', error));
    },
    like(id) {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("VoteID", id);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "CommonMethod/SetVoteLike", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.showLoaderDialog = false
            this.resultText = result
            this.showResult = true
            this.getStoreDetail()
          })
          .catch(error => console.log('error', error));
    },
    dislike(id) {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("VoteID", id);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "CommonMethod/SetVoteDislike", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.showLoaderDialog = false
            this.resultText = result
            this.showResult = true
            this.getStoreDetail()
          })
          .catch(error => console.log('error', error));
    },
    openMap(lat, lng) {
      let a = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display: none";
      a.href = "https://www.google.com.sa/maps/search/" + lat + ',' + lng + "?hl=en"
      a.target = '_blank'
      // a.download = <your_fileName>;
      a.click();
      document.body.removeChild(a);
    },
    goToCommentOwner(item){
      if(item.TypeRoleCommentOwner === "Vendor"){
        this.$router.push({path:'StoreProfile',query:{VendorID:item.VendorCommentOwnerId}})
      }else {
        this.$router.push({path:'ProfileInSite',query:{ID:item.AppUserId}})
      }
    }
  }
}
</script>

<style scoped>

</style>
